/**
 * @module
 *
 * @description Mortgages driver configurations
 */
import { getMaxLtvText, getMinDownPayment, getMinDownPaymentTooltip } from '../selectors/mortgages';
import { getLoanTypeAndProductLabels, getCoverageAreaLabel } from '../utils/mortgages';
import { VALUE_SIZES } from '../constants/drivers';
/**
 * Get the loan types & products driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverLoanTypesAndProducts = function getDriverLoanTypesAndProducts(offer) {
  return {
    id: 'loanTypesProducts',
    label: 'Loan Types and Products',
    value: getLoanTypeAndProductLabels(offer).join(', '),
    valueSize: VALUE_SIZES.MEDIUM
  };
};
/**
 * Get the max LTV driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMaxLtv = function getDriverMaxLtv(offer) {
  return {
    id: 'maxLtv',
    label: 'Max LTV',
    value: getMaxLtvText(offer)
  };
};
/**
 * Get the min down payment driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverMinDownPayment = function getDriverMinDownPayment(offer) {
  return {
    id: 'minDownPayment',
    label: 'Min. Down Payment',
    value: getMinDownPayment(offer),
    valueTooltip: getMinDownPaymentTooltip(offer)
  };
};
/**
 * Get the min down payment driver.
 * @param {object} offer - The marketplace offer.
 * @return {object} - The "quick fact" driver.
 */

export var getDriverNationalRegional = function getDriverNationalRegional(offer) {
  return {
    id: 'nationalRegional',
    label: 'National / Regional',
    value: getCoverageAreaLabel(offer)
  };
};
/**
 * @todo - getDriverMinCreditScore
 * Needs structured content support.
 * @see {@link https://github.com/NerdWallet/react-components/blob/2ecec93b1f88e88246e6ffbc3e2f7bcdabdb9471/components/quick-facts/src/mappings/mortgages.jsx#L43-L86}
 */